import * as React from "react"

const SvgDesign = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m8.8 10.95 2.15-2.175-1.4-1.425-.4.4a.98.98 0 0 1-.688.288.93.93 0 0 1-.712-.288q-.3-.3-.3-.712 0-.413.3-.713l.375-.375L7 4.825 4.825 7zm8.2 8.225L19.175 17l-1.125-1.125-.4.375q-.3.3-.7.3a.96.96 0 0 1-.7-.3.96.96 0 0 1-.3-.7q0-.4.3-.7l.375-.4-1.425-1.4-2.15 2.15zM4 21a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 20v-2.825q0-.2.075-.387a1 1 0 0 1 .225-.338l4.075-4.075L3.05 8.05A1.43 1.43 0 0 1 2.625 7q0-.625.425-1.05l2.9-2.9q.425-.424 1.05-.412a1.47 1.47 0 0 1 1.05.437L12.4 7.4l3.775-3.8q.3-.3.675-.45a2.07 2.07 0 0 1 1.55 0q.375.15.675.45L20.4 4.95q.3.3.45.675T21 6.4a1.98 1.98 0 0 1-.6 1.425l-3.775 3.8 4.325 4.325q.425.424.425 1.05t-.425 1.05l-2.9 2.9a1.43 1.43 0 0 1-1.05.425q-.626 0-1.05-.425l-4.325-4.325L7.55 20.7a1 1 0 0 1-.725.3zm1-2h1.4l9.8-9.775L14.775 7.8 5 17.6z" />
  </svg>
)
export default SvgDesign
